// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"64":"b9223cc5","150":"f0c88f3f","740":"ca7d8455"}[chunkId] + ".chunk.js");